const Monday = 1

export default Monday
